export default __webpack_public_path__ + "static/media/119.70eb0e14.png";